import {TableButtonOptions} from "../../../Modules/ListPage/Components/Table/Buttons/TableButtonGroup";
import {dayMonthYearAtTime} from "../../Utils/DateFormat";
import {formatCnpjCpf} from "../../Utils/Format";
import {BlockTenantTableButton} from "../../../Modules/Auth/Tenant/Component/BlockTenantTableButton";
import {InputMaskedRegistrationNumber} from "../../Component/Input/InputMaskedRegistrationNumber";
import RegistrationTypeSelector, {
    REGISTRATION_TYPES
} from "../../../Modules/Auth/Tenant/Component/RegistrationTypeSelector";


const USER_SCHEMA_NAME = 'empresas';

export const TenantCustomSchema = (name, schema) => {


    if (!(name === USER_SCHEMA_NAME)) {
        return;
    }

    console.log('Customizando Tenant list schema', name, schema)

    const endpoint = `${process.env.REACT_APP_AUTH_SERVICE}v1/companies`;

    schema.getTitle = () => 'Lista de Empresas';
    schema.getEndpoint = () => endpoint;

    schema.getColumns = () => {
        return [
            TableButtonOptions({
                deleteEndpoint: endpoint,
                children: ({row, table, cell}) => {
                    return <BlockTenantTableButton row={row} updateTable={() => {
                        table.setGlobalFilter(new Date());
                        console.log('atualiza tabela ai')
                    }}/>
                }
            }),
            {
                header: "Nome",
                accessorKey: "name"
            },

            {
                header: "CPF/CNPJ",
                accessorKey: "registrationNumber",
                accessorFn: (row) => formatCnpjCpf(row.registrationNumber)
            },

            {
                header: "Criado em",
                accessorKey: "createdAt",
                filter: false,
                cell: (row) => dayMonthYearAtTime(row.createdAt)
            },
        ]
    }

    schema.customizeResponseData = (data) => {
        return {
            content: data.content,
            pageCount: data.number,
            totalElements: data.totalElements,
            totalPages: data.totalPages
        }
    }
}

export const TenantCustomFormSchema = (name, schema) => {
    if (!(name === USER_SCHEMA_NAME)) {
        return;
    }

    console.log('Customizando Tenant form schema', name, schema);

    schema.getByIdUrl = (id) => `${process.env.REACT_APP_AUTH_SERVICE}v1/companies/${id}`;

    schema.getSaveUrl = (id) => `${process.env.REACT_APP_AUTH_SERVICE}v1/companies/${id || ''}`;


    schema.formatObjectToSave = (formData) => {
        formData.registrationType = formData.registrationType.id;
        return formData;
    };

    schema.formatObjectToGet = (formData) => {
        formData.registrationType = REGISTRATION_TYPES.filter(x => x.id === formData.registrationType)[0];
        return formData;
    };


    schema.uiSchema = {
        "name": {
            "ui:autofocus": true,
        },
        "registrationNumber": {
            "ui:help": "CPF ou CNPJ da empresa 000.000.000-00 ou 00.000.000/0000-00",
            "ui:field": (props) => {
                return (<InputMaskedRegistrationNumber id="registrationNumber"
                                                       title={props.schema.title} mask={props.schema.mask}
                                                       onChangeText={props.onChange} value={props.formData}/>)
            },
        },
        "registrationType": {
            "ui:options": {
                label: false
            },
            "ui:field": (props) => {
                return (<RegistrationTypeSelector disabled={props.disabled} required={props.required}
                                                  value={props.formData} setValue={props.onChange}/>
                );
            }
        }
    };

    schema.formSchema = {
        // title: "Empresa",
        type: "object",
        required: ["name"],
        properties: {
            name: {type: "string", title: "Nome Fantasia"},
            registrationType: {
                type: "object",
                title: "Tipo de Pessoa",
                required: ["id"],
                properties: {
                    id: {
                        type: 'string',
                        "default": REGISTRATION_TYPES[1].id,
                    },
                    label: {
                        type: 'string',
                        "default": REGISTRATION_TYPES[1].label,
                    }
                }
            },
        },
        "dependencies": {
            "registrationType": {
                "oneOf": [
                    {
                        "properties": {
                            "registrationType": {
                                "properties": {
                                    "id": {
                                        "enum": [
                                            REGISTRATION_TYPES[0].id
                                        ]
                                    }
                                }
                            },
                            "registrationNumber": {
                                "type": "string",
                                "mask": "0",
                                title: 'CPF'
                            }
                        },
                    },

                    {
                        "properties": {
                            "registrationType": {
                                "properties": {
                                    "id": {
                                        "enum": [
                                            REGISTRATION_TYPES[1].id
                                        ]
                                    }
                                }
                            },
                            "registrationNumber": {
                                "type": "string",
                                minLength: 14,
                                maxLength: 14,
                                "mask": "1",
                                title: "CNPJ"
                            }
                        },
                    }
                ]
            }
        }
    }

}
